import { IBasicUser } from '../core/models/basic-user.model';
import { ICharacteristicType } from '../core/models/characteristic-type.model';
import {
	IDcMetadataResponse,
	IMetadataTag,
} from '../core/models/metadata.model';

export type HeadersReferencingMode = 'LABEL' | 'POSITION';

export type HttpIterationMode = 'WITHOUT' | 'PER_PAGE' | 'PER_OFFSET';

export interface IAdditionalParams {
	method?: string;
	body?: string;
	headers?: Map<string, string>;
	iteration?: { mode?: HttpIterationMode };
}
export interface IDepot {
	id: number;
	code?: string;
	depot_type: string;
	metadata?: IDcMetadataResponse;
	connector: {
		id: number;
		connector_type: string;
		metadata?: IDcMetadataResponse;
	};
	headers_referencing_mode?: HeadersReferencingMode;
	additional_params?: IAdditionalParams;
}

export interface IDepotEntityBulkCount {
	id: number;
	count: number;
}

export interface IDepotResponse {
	id: number;
	metadata_id?: number;
	code?: string;
	label?: string;
	description?: string;
	icon_id?: number;
	tags?: Array<IMetadataTag>;
	active?: boolean;
	imported?: boolean;
	creation_date?: string;
	created_by?: IBasicUser;
	update_date?: string;
	updated_by?: IBasicUser;
	project?: {
		id: number;
		label?: string;
		code?: string;
		icon_id?: number;
	};
	type: string;
	connector: {
		id: number;
		metadata_id?: number;
		code?: string;
		label?: string;
		tags?: Array<IMetadataTag>;
		icon_id?: number;
		creation_date?: string;
		created_by?: IBasicUser;
		update_date?: string;
		active?: boolean;
		imported?: boolean;
		project?: {
			id: number;
			label?: string;
			code?: string;
			icon_id?: number;
		};
		type?: string;
	};
	entitiesCount?: number;
}

export enum ColumnTypeModel {
	STRING_TYPE = 'StringType',
	INTEGER_TYPE = 'IntegerType',
	BIG_INTEGER_TYPE = 'LongType',
	DECIMAL_TYPE = 'DecimalType',
	DATE_TYPE = 'TimestampType',
	BOOLEAN_TYPE = 'BooleanType',
	WORDS_TYPE = 'WordsType',
	FILE_TYPE = 'FileType',
	BINARY_TYPE = 'BinaryType',
	GEOMETRY_TYPE = 'GeometryType',
}

export interface IDepotHeaderResponse {
	id: number;
	column: string;
	position: number;
	depot_details: boolean;
	data_type: ColumnTypeModel;
	original_name?: string;
	date_pattern?: string;
	list?: boolean;
}

export interface ICharacteristicEntityModel {
	code?: string;
	tempCode?: string;
	oldCode?: string;
	complex?: boolean;
	date_pattern?: string;
	depotDetails?: boolean;
	label?: string;
	lib?: string;
	origin_column_id?: string;
	poids?: number;
	entite_type?: ICharacteristicType;
	list?: boolean;
}

export interface IMappingDepotModel {
	header?: { id: number };
	is_formula?: boolean;
	uca_code?: string;
	pattern?: string;
	timezone?: string;
	language?: string;
}

export interface IDepotEntityCreate {
	caracs: Array<ICharacteristicEntityModel>;
	entity?: {
		actif?: boolean;
		description?: string;
		label?: string;
		icon_id?: number;
		tags?: Array<IMetadataTag>;
	};
	mappings: Array<IMappingDepotModel>;
}

type DepotSchemaEntryType = 'STRUCT' | 'ARRAY' | 'LEAF' | 'SIMPLE_ARRAY';

export interface ISchemaDefinitionModel {
	element_name?: string;
	final_name?: string;
	element_code?: string;
	type: DepotSchemaEntryType;
	keep: boolean;
	ignore_subtree?: boolean;
	children: Array<ISchemaDefinitionModel>;
	data_type?: string;
	convert_to?: string | null;
	convert_to_format?: string;
	convert_to_tz?: string;
	convert_to_language?: string;
	position?: number;
}

type SchemaRoot = {
	type: 'ROOT';
	children: Array<ISchemaDefinitionModel>;
	keep: boolean;
};

export interface IDepotSchemaModel {
	schema: SchemaRoot;
	headers: Array<string>;
}

export type CompatabilityInfo = {
	source_version_id?: number;
	target_version_id?: number;
	compatible?: boolean;
	missing_columns?: Array<string>;
	added_columns?: Array<string>;
	current_columns?: Array<{
		column_uuid?: string;
		name?: string;
		type?: string;
		list?: boolean;
	}>;
	candidate_columns?: Array<{
		column_uuid?: string;
		name?: string;
		type?: string;
		list?: boolean;
	}>;
};

export interface IDataLinkRepoVersion {
	data_link_id?: number;
	version?: string;
	version_description?: string;
	subscription_id?: number;
	current?: boolean;
	active?: boolean;
	switchable?: boolean;
	compatibility?: CompatabilityInfo;
}
